import { render } from "./RegisterStep7.vue?vue&type=template&id=05a0aa8c&scoped=true"
import script from "./RegisterStep7.vue?vue&type=script&lang=js"
export * from "./RegisterStep7.vue?vue&type=script&lang=js"

import "./RegisterStep7.vue?vue&type=style&index=0&id=05a0aa8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a0aa8c"]])

export default __exports__